import React from 'react'
import { TextInput, type TextInputProps } from '@common/ui'

const TrimmedTextInput = ({ onBlur, ...props }: TextInputProps) => {
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const trimmed = event.target.value.trim()
    if (trimmed !== event.target.value) {
      // Can't call props.onChange directly: event.target is a live DOM node and
      // can't be meaningfully cloned. Using the native setter lets React's reconciler
      // read the updated value from the real element as it normally would.
      const nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set
      nativeSetter?.call(event.target, trimmed)
      event.target.dispatchEvent(new Event('input', { bubbles: true }))
    }
    onBlur?.(event)
  }
  return <TextInput onBlur={handleBlur} {...props} />
}

TrimmedTextInput.displayName = 'TrimmedTextInput'

export default TrimmedTextInput
